module.exports = __webpack_public_path__ + "static/media/as.078ba745.svg";